import {
  createAsyncThunk,
} from '@reduxjs/toolkit';

import type { EntityDataPubType } from '@/domain/entityBase';
import type { SentNewsJsonPub, SentNewsJsonPvt } from '@/domain/news/service/entity/sentNewsEntity';
import type { ThunkApiType } from '@/store';

import { newsSlice } from '@/domain/news/redux';
import { uiSlice } from '@/domain/ui/redux';
import { ApiResponseError } from '@/errors/apiResponseError';
import { service } from '@/share';

export const refreshNewsList = createAsyncThunk<
  void,
  void,
  ThunkApiType
>(
  'news/refreshNewsList',
  async (_, thunkApi) => {
    const result = await service.news.getSentNewsList(null);
    thunkApi.dispatch(newsSlice.actions.setSentNewsList(result));
  },
);

export const setSentNewsDetail = createAsyncThunk<
  void,
  {
    /** 項目 */
    item: EntityDataPubType<SentNewsJsonPvt, SentNewsJsonPub> | undefined,
  },
  ThunkApiType
>(
  'news/setSentNewsDetail',
  async (input, thunkApi) => {
    if (input.item) {
      try {
        thunkApi.dispatch(uiSlice.actions.startBlocking());
        const result = await service.news.loadContent(input.item);
        thunkApi.dispatch(newsSlice.actions.setSentNews(result));
        thunkApi.dispatch(uiSlice.actions.endBlocking());
        if (!result.info.pub.data.alreadyRead) {
          await service.news.alreadyReadNews(result.info);
        }
      } catch (e) {
        if (e instanceof ApiResponseError) {
          thunkApi.dispatch(uiSlice.actions.setMessage({
            key: 'error',
            content: 'データの取得に失敗しました',
          }));
        } else {
          throw e;
        }
      } finally {
        thunkApi.dispatch(uiSlice.actions.endBlocking());
      }
    } else {
      thunkApi.dispatch(newsSlice.actions.setSentNews(undefined));
    }
  },
);

export const getNewsList = createAsyncThunk<
  void,
  void,
  ThunkApiType
>(
  'news/getNewsList',
  async (_, thunkApi) => {
    const { nextTokenSentNews, sentNewsList } = thunkApi.getState().news;
    const result: {
      items: EntityDataPubType<SentNewsJsonPvt, SentNewsJsonPub>[],
      nextToken: string,
    } = await service.news.getSentNewsList(nextTokenSentNews);
    const newList = sentNewsList.map((v) => v);
    for (let i = 0; i < result.items.length; i += 1) {
      newList.push(result.items[i]);
    }
    thunkApi.dispatch(newsSlice.actions.setSentNewsList({
      items: newList,
      nextToken: result.nextToken,
    }));
  },
);
